@if (showPage()) {
<div class="updates-container">
  <ng-scrollbar>
    <div id="product-updates-view" class="ot-panel">
      <div class="ot-panel__header">
        @if (!isAgentOnline) {
        <div id="product-updates-agent-offline-error" class="ot-message ot-message--is-error">
          <div class="ot-message__banner">
            @if (isMasterSystemSupported) {
            <p class="ot-message__item" i18n>
              The agent on the primary system is offline.
            </p>
            }
            @if (!isMasterSystemSupported) {
            <p class="ot-message__item" i18n>
              All agents are currently offline.
            </p>
            }
          </div>
        </div>
        }
        @if (isAgentOnline && isQuickAnalysisRequired) {
        <div id="product-updates-agent-analysis-error" class="ot-message ot-message--is-error">
          <div class="ot-message__banner">
            <p class="ot-message__item" i18n>
              An analysis of the primary system must be completed before continuing.&nbsp;<a
                (click)="analyzeMasterSystemClicked()">Analyze primary system</a>
            </p>
          </div>
        </div>
        }
        @if (isAgentOnline && !isQuickAnalysisRequired && !isMasterSystemSelected) {
        <div id="product-updates-agent-selection-error" class="ot-message ot-message--is-error">
          <div class="ot-message__banner">
            <p class="ot-message__item" i18n>
              An issue with primary system selection has been detected.&nbsp;<a
                [routerLink]="['/products/componentdetails/' + productId + '/' + setupId]">Resolve the issue</a>
            </p>
          </div>
        </div>
        }
        @if ((activeUpdate && !isQuickAnalysisRequired) || activeComponent) {
        <div class="ot-form-control ot-mb-0" style="flex-direction: unset;">
          <div class="otsc-prop-header otsc-prod-updates-prop-header">
            <h1 class="otsc-prop-header-text"></h1>
            <div class="ot-btn-group otsc-prop-header-btn">
              @if (isOnlineMode) {
              <button id="product-updates-download-button" role="button" class="ot-btn ot-btn--is-primary"
                [disabled]="itemsToDownload.isEmpty() || itemsToDownload.isDownloadInProgress() || hotfixLoading"
                (click)="download()" i18n>
                @if (!itemsToDownload.isDownloadInProgress()) {
                <span>
                  {itemsToDownload.getTotalItems(),
                  plural,
                  =0 {No items to download}
                  =1 {
                  Download 1 item
                  }
                  other {Download {{itemsToDownload.getTotalItems()}} items}
                  }
                </span>
                } @else {

                <div id="product-updates-download-button-progress"
                  class="otsc-dowloading-btn ot-progress ot-progress--is-spinner">
                  <div class="ot-progress__outer">
                    <div class="otsc-dowloading-btn-spinner ot-progress__meter"></div>
                    <div class="ot-progress__text" i18n-title title="Downloading...">Downloading...</div>
                  </div>
                </div>

                }

              </button>
              }
              @if (!isOnlineMode && activeUpdate && activeUpdate.status !== 'INSTALLED') {
              <button id="product-updates-offline-download-button" role="button" i18n-title title="Download"
                (click)="openOfflineDownloadLink(activeUpdate.details.downloadURL)" class="ot-btn ot-btn--is-primary"
                i18n>
                Download
              </button>
              }
              <div class="ot-dropdown ot-pl-1" [ngClass]="{'ot-dropdown--is-active': isExportBtnClicked}">
                <button id="product-updates-export-button" role="button" i18n-title title="Export metadata"
                  (click)="toggleExportMenu()" class="ot-btn ot-btn--is-secondary"
                  [disabled]="itemsToDownload.isEmpty() || itemsToDownload.isDownloadInProgress() || hotfixLoading"
                  i18n>
                  Export metadata
                </button>
                <ul id="product-updates-export-menu-body" class="ot-dropdown__menu">
                  <li id="product-updates-export-menu-csv-item" class="ot-dropdown__item"
                    (click)="exportMetadataAsCSV()" i18n>
                    CSV (comma-separated values) file
                  </li>
                  <li class="ot-dropdown__divider">
                  </li>
                  <li id="product-updates-export-menu-webpage-item" class="ot-dropdown__item"
                    (click)="exportMetadataAsWebPage()" i18n>
                    Web page
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        }
      </div>
      @if ((activeUpdate && !isQuickAnalysisRequired) || activeComponent) {
      <div class="ot-panel__body ot-pl-0 ot-pr-0 ot-pb-0 updates-content-area">
        <div class="ot-row ot-pl-1 ot-pr-1" style="width: unset;">
          <div class="ot-row__column">
            <small class="ot--has-text-muted" i18n>Version</small>
            <p id="product-updates-version">{{summaryVersion}}</p>
          </div>
          <div class="ot-row__column">
            <small class="ot--has-text-muted" i18n>Status</small>
            @switch (summaryStatus) {
            @case ('ERROR') {
            <div id="product-updates-status-download-error"
              class="ot-message ot-message--is-error otsc-message--is-light">
              <div class="ot-message__banner">
                <p class="ot-message__item" i18n>
                  Error downloading the item
                </p>
              </div>
            </div>
            }
            @case ('COMPLETE') {
            <div id="product-updates-status-download-complete"
              class="ot-message ot-message--is-success otsc-message--is-light">
              <div class="ot-message__banner">
                <p class="ot-message__item" i18n>
                  Downloaded
                </p>
              </div>
            </div>
            }
            @case ('AVAILABLE') {
            <div id="product-updates-status-download-available"
              class="ot-message ot-message--is-info otsc-message--is-light">
              <div class="ot-message__banner">
                <p class="ot-message__item" i18n>
                  Available for download
                </p>
              </div>
            </div>
            }
            @case ('INSTALLED') {
            <div id="product-updates-status-download-installed"
              class="ot-message ot-message--is-success otsc-message--is-light">
              <div class="ot-message__banner">
                <p class="ot-message__item" i18n>
                  Installed
                </p>
              </div>
            </div>
            }
            @default {
            <div id="product-updates-status-download-progress"
              class="ot-message ot-message--is-info otsc-message--is-light">
              <div class="ot-message__banner">
                <p class="ot-message__item" i18n>
                  Downloading...
                </p>
              </div>
            </div>
            }
            }
          </div>
          <div class="ot-row__column">
            <small class="ot--has-text-muted" i18n>Description</small>
            @if (summaryDescription) {
            <p id="product-updates-description">{{summaryDescription}}</p>
            } @else {
            <p i18n>N/A</p>
            }
          </div>
          <div class="ot-row__column">
            <small class="ot--has-text-muted" i18n>Size</small>
            @if (summarySize) {
            <p id="product-updates-size">{{summarySize}}</p>
            } @else {
            <p i18n>N/A</p>
            }
          </div>
          <div class="ot-row__column">
            <small class="ot--has-text-muted" i18n>Zero Downtime</small>
            @if(summaryZeroDowntime) {
            <p id="product-updates-release-date" i18n>Supported</p>
            } @else {
            <p id="product-updates-release-date" i18n>Not supported</p>
            }
          </div>
          <div class="ot-row__column">
            <small class="ot--has-text-muted" i18n>Release date</small>
            @if (summaryReleaseDate) {
            <p id="product-updates-release-date">{{summaryReleaseDate | date:'EEEE, LLLL d, yyyy'}}</p>
            } @else {
            <p i18n>N/A</p>
            }
          </div>
        </div>
        @if (activeUpdate && activeUpdate.isSupportHotfix) {
        @if (!hotfixLoading && supercededPatches.length > 0) {
        <div class="ot-row" style="margin-bottom: 0px;">
          <div class="ot-message ot-message--is-warning w-100">
            <div class="ot-message__banner">
              <p id="product-updates-superseded-patch-msg" class="title" i18n>
                {supercededPatches.length,
                plural,
                =1 { One superseded patch was skipped }
                other { {{supercededPatches.length}} superseded patch were skipped}
                }
              </p>
            </div>
          </div>
        </div>
        }
        @if (requestFailed) {
        <div id="request-eeror" class="ot-message ot-message--is-error">
          <div class="ot-message__banner">
            <p class="ot-message__item">{{requestErrorMessage}}</p>
          </div>
        </div>
        }
        <div #productupdatecontainer id="product-update-tab-area">
          <app-tabs [identifier]="'product-updates-tabs'" (selected)="onSelectedTabChange($event)" [tabs]="tabs"
            [color]="TabColor.SECONDARY" [selectedIndex]="activeTab" [selectOnInit]="false"></app-tabs>
          @if (activeTab == UpdateTab.PATCHES) {
          <div>
            <app-datatable [identifier]="'product-updates-hotfix-table'" [scroll]="false"
              [disableSelectAllCheckbox]="itemsToDownload.isDownloadInProgress()"
              [overrideSelectAll]="overrideHotfixSelectAll" (selectAllClickEvent)="selectAllHotfix($event)"
              [recountSelectedRow]="recountSelectedRow" (checkboxchangeevent)="hotfixRowClicked($event)" [title]="''"
              [showcheckboxes]="true" [cols]="hotfixTableCols" [rows]="hotfixTableRows" [isloading]="hotfixLoading"
              (actionmenuevent)="actionMenuClicked($event)" (rowclickevent)="rowClick($event)"></app-datatable>
          </div>
          }
          @if (activeTab == UpdateTab.LANGUAGES) {
          <div>
            <app-datatable [identifier]="'product-updates-langpack-table'" [scroll]="false"
              [disableSelectAllCheckbox]="itemsToDownload.isDownloadInProgress()"
              (checkboxchangeevent)="langpackRowClicked($event)" (selectAllClickEvent)="selectAllLangPack($event)"
              [title]="''" [showcheckboxes]="true" [cols]="langPackTableCols" [rows]="langPackTableRows"
              (actionmenuevent)="langActionMenuClicked($event)" (rowclickevent)="rowClick($event)"></app-datatable>
          </div>
          }
        </div>
        }
        @if (activeComponent && activeProduct && activeProduct.components && activeProduct.isMultiComponent) {
        <app-tabs [identifier]="'component-tabs'" (selected)="onSelectedTabChange($event)" [tabs]="componentTabs"
          [color]="TabColor.SECONDARY" [selectedIndex]="activeComponentTab"></app-tabs>
        @if (activeComponentTab == ComponentTab.COMPONENTS) {
        <div [style.height]="componentTableRows.length > 0 ? '430px' : '365px'">
          <app-datatable [identifier]="'product-components-table'"
            [disableSelectAllCheckbox]="itemsToDownload.isDownloadInProgress() || summaryStatus == 'COMPLETE'"
            [overrideSelectAll]="overrideHotfixSelectAll" (selectAllClickEvent)="selectAllComponents($event)"
            [recountSelectedRow]="recountSelectedRow" (checkboxchangeevent)="componentRowChecked($event)" [title]="''"
            [showcheckboxes]="true" [cols]="componentTableCols" [rows]="componentTableRows"
            [isloading]="componentsLoading" (actionmenuevent)="actionMenuClicked($event)"
            (rowclickevent)="rowClick($event)"></app-datatable>
        </div>
        }
        }
      </div>
      } @else {
      @if (isAgentOnline) {
      <div id="product-updates-no-updates" style="height:100vh">
        <div class="otsc-no-items__icon"></div>
        <div class="otsc-no-items__text" i18n>
          There are no updates to display.
        </div>
      </div>
      }
      @if (!isAgentOnline) {
      <div id="product-updates-agents-offline" style="height:100vh">
        <div class="otsc-no-agents__icon"></div>
        <div class="otsc-no-agents__text">
          <span class="otsc-no-agents__text-header" i18n>All agents are currently offline.</span>
          <span class="otsc-no-agents__text-msg" i18n>In order to view the list of available patches at least one
            registered agent must be online. <br /> If a registered product requires a primary system it must also be
            online.</span>
        </div>
      </div>
      }
      }
    </div>
  </ng-scrollbar>
</div>
} @else {
<div id="product-updates-loading"
  class="ot-progress ot-progress--is-bouncer ot-progress--is-bouncer-big ot-progress--is-bouncer-has-text">
  <div class="ot-progress__outer">
    <div class="ot-progress__meter"></div>
  </div>
  @if (isLoading && !isManifestUpdating && !isAgentManifestUpdating) {
  <div class="ot-progress__text" i18n>Loading...</div>
  }
  @if (isManifestUpdating) {
  <div class="ot-progress__text" i18n>Please wait while the manifest is updated...</div>
  }
  @if (isAgentManifestUpdating) {
  <div class="ot-progress__text" i18n>Please wait while the Agent manifest is updated...</div>
  }
</div>
}